import * as React from 'react';
import { useParams } from 'react-router-dom';
import { LoadingOverlay } from '@davies-group/white-label-ui/ui';

import useAssessmentManager from '../plugins/useAssessmentManager';

export type QueryParameters =
{
	assessmentId: string
}

export default function AssessmentLoadingPage()
{
	const urlParams = useParams<QueryParameters>();
	const assessmentManager = useAssessmentManager();

	React.useEffect(() =>
	{
		assessmentManager
			.loadAssessment(urlParams.assessmentId ?? '')
	}, []);

	return <LoadingOverlay isLoading={true}/>
}
